<div *ngIf="isPageReady" id="printable-po" class="flex h-full">
  <div class="center no-print flex grow flex-col border-2 p-2 shadow-lg" style="max-width: 8.5in; min-width: 8.5in">
    <div *ngIf="!poHeader" #printableArea class="screen-p-20">
      <h2>Error: Purchase Order {{ poHeaderId }} not found.</h2>
    </div>
    <div *ngIf="poHeader" #printableArea class="screen-p-20 grow" style="overflow: auto">
      <div uni-flex-row class="h2 mt-1">
        <span style="flex: auto">Unitec Distribution Systems</span>
        <span>Purchase Order {{ displayPoNumber }}</span>
      </div>
      <div *ngIf="isSent" uni-flex-row style="margin-bottom: -20px">
        <span style="flex: auto">&nbsp;</span>
        <span *ngIf="isSent" class="h1" style="font-style: italic; color: gray">REPRINT</span>
      </div>

      <div uni-flex-row class="align-items-start mt-4">
        <uni-field uni-flex-item label="Manufacturer">
          <textarea
            id="poManufacturerTextArea"
            pInputText
            rows="7"
            [ngModel]="getAddress(poHeader.manufacturer, 'wh', true, true)"
            readonly="readonly"
          ></textarea>
        </uni-field>
        <uni-field uni-flex-item label="Ship this order to">
          <textarea pInputText rows="7" [ngModel]="getAddress(poHeader.shippingWarehouse, 'wh', true, true)" readonly="readonly"></textarea>
        </uni-field>
      </div>

      <div uni-flex-row uni-flex-nowrap class="ml-3 mt-2">
        <uni-field label="Account #">
          <input pInputText [ngModel]="poHeader.manufacturer.accountReferenceName" readonly="readonly" />
        </uni-field>
        <uni-field label="P/O No.">
          <input pInputText [ngModel]="displayPoNumber" readonly="readonly" />
        </uni-field>
        <uni-field label="P/O Date/Time">
          <input pInputText [ngModel]="poDate | date: 'short'" readonly="readonly" />
        </uni-field>
        <uni-field label="F.O.B">
          <input pInputText value="Destination" readonly="readonly" />
        </uni-field>
      </div>

      <div uni-flex-row class="ml-2 mt-3">
        <table class="grid-print" style="font-size: 10pt">
          <thead>
            <tr>
              <th class="col-left">Style</th>
              <th class="col-left">Description</th>
              <th class="col-left">Size</th>
              <th class="col-right">Qty</th>
              <th class="col-left">Deliver By</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let d of flatDetails">
              <td>{{ d.style }}</td>
              <td>{{ d.desc }}</td>
              <td>{{ d.featureChoicesExtract }}</td>
              <td class="col-right">{{ d.qty }}</td>
              <td>{{ d.ddate | date: 'MM/dd/yyyy' }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>&nbsp;</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div uni-flex-row class="ml-2 mt-3">
        <uni-field uni-flex-item label="Order note">
          <textarea pInputText rows="6" [ngModel]="getOrderNote()" readonly="readonly" style="font-size: 9pt"> </textarea>
        </uni-field>
      </div>
    </div>

    <div uni-flex-row class="accent no-print mb-2">
      <div>
        <button id="poPrintEmailButton" pButton type="button" class="p-button-raised" [disabled]="!poHeader" (click)="showPrintDialog()">
          <span>Print / Email</span>
        </button>

        <span style="margin-left: 8px">{{ email?.status }} {{ email?.statusTs | date: 'long' }}</span>
      </div>

      <div>
        <button pButton type="button" class="p-button-raised" [disabled]="!poHeader" (click)="goToPo()">
          <span>Go to P/O Details</span>
        </button>
        <button pButton type="button" class="p-button-raised ml-3" icon="pi pi-arrow-left" (click)="goBack()">
          <span>Go Back</span>
        </button>
      </div>
    </div>
  </div>
  <p-confirmDialog></p-confirmDialog>
  <!-- / CENTER -->
</div>
